<template>
  <div>
    <div class="mt-2">
      <div class="d-flex">
        <i class="far fa-clock text-orange mr-2 mt-1"></i>
        <p class="font-weight-normal font-18">
          Historial de Estatus
        </p>
      </div>
    </div>
    <div v-if="pagination.data.length">
      <time-line>
        <div v-for="item in pagination.data" :key="item.id">
          <time-line-item class="custom-time-line rounded">
            <template #icon>
              <em class="radius text-white" :class="icon(item.reason?.id)"></em>
            </template>
            <template #date>
              <div class="date-container">
                <label class="text-gray font-weight-light font-14">
                  Fecha:
                </label>
                <div class="color-black font-16">
                  {{ item.createdDate | date }}
                </div>
                <div class="color-black font-16">
                  {{ item.createdDate | hour }}
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col">
                <custom-input-display
                  label="Razón de cambio:"
                  label-class="text-gray font-weight-light"
                  :value="item.reason?.name"
                />
              </div>
              <div class="col">
                <custom-input-display
                  label="Usuario:"
                  label-class="text-gray font-weight-light"
                  :value="item.user.name"
                />
              </div>
              <div class="col">
                <label class="text-gray font-weight-light">Estatus:</label>
                <custom-balloon
                  dot
                  :text="item.newStatus.name"
                  :background-color="item.newStatus.color"
                />
              </div>
              <div class="col">
                <custom-input-display
                  label="Nivel de Prioridad:"
                  label-class="text-gray font-weight-light"
                  :value="item.newPriorityLevel?.name"
                />
              </div>
            </div>
            <div
              class="bg-white rounded p-3 m-3"
              v-if="item.closingDate || item.comment"
            >
              <div class="row">
                <div class="col" v-if="item.closingDate">
                  <custom-input-display
                    label="Fecha de Cierre:"
                    label-class="text-gray font-weight-light"
                    :value="item.closingDate | date"
                  />
                </div>
                <div class="col" v-if="item.comment">
                  <custom-input-display
                    label="Comentario:"
                    label-class="text-gray font-weight-light"
                    :value="item.comment"
                  />
                </div>
              </div>
            </div>
          </time-line-item>
        </div>
      </time-line>

      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="(page) => $emit('search', page)"
      />
    </div>

    <custom-result-not-found
      v-else
      class="mt-4 row mx-auto pt-3"
      text="No hay Información Disponible."
    />

    <div class="d-flex justify-content-end mt-4">
      <action-button
        text="Cerrar"
        i="fas fa-times-circle"
        variant="outline-danger"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomBalloon from 'custom-balloon';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';

// constants
import { icons as changeReasonIcons } from '@/utils/constants/tapRequest/alternativeLocationActionPlanStatusChangeReason.js';

export default {
  name: 'PlanActionHistory',
  components: {
    CustomInputDisplay,
    ActionButton,
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    CustomResultNotFound,
    Pagination,
  },
  props: {
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    icon() {
      return (id) => (id ? changeReasonIcons[id] : 'fas fa');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

:deep(.w-date-fixed) {
  width: 120px !important;
}
</style>
